module.exports = {
    "ApiUrl": "https://resman-integration-api-ci.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://resman-integration-identity-ci.icarehealth.com.au",
    "SignalRUrl": "https://resman-integration-api-ci.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};
